module.exports = __webpack_public_path__ + "static/media/google_21.01eb07ad.svg";